var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useContext, useState } from 'react';
import { createGlobalStyle, css, ThemeContext, ThemeProvider } from 'styled-components';
import { useSpring } from '@react-spring/web';
import kebabcase from 'lodash.kebabcase';
import { color } from './color';
import { borderRadius } from './border-radius';
import { border } from './border';
import { shadow } from './shadow';
export const Themes = {
    light: {
        color: color.light,
        borderRadius,
        border: {
            borderRight: undefined,
        },
        shadow: Object.assign(Object.assign({}, shadow), { outline: undefined, border: undefined }),
    },
    dark: {
        color: color.dark,
        border,
        borderRadius,
        shadow,
    },
};
const defaultConfig = {
    type: 'light',
    theme: Themes.light,
};
export const GranenThemeContext = React.createContext(defaultConfig);
export const useTheme = () => {
    const theme = useContext(ThemeContext);
    const { type, handleChangeTheme } = useContext(GranenThemeContext);
    return {
        theme,
        type,
        handleChangeTheme,
    };
};
/**
 * @description set css variables
 */
const setThemeCssVariable = (theme) => {
    Object.keys(theme).forEach((key) => {
        var _a, _b;
        ;
        (_b = (_a = document.querySelector(':root')) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.setProperty(`--${kebabcase(key)}`, theme[key]);
    });
};
const CssVar = css `
  :root {
    ${(props) => Object.keys(props.theme.color).map((key) => {
    return `--${kebabcase(key)}: ${props.theme.color[key]};`;
})}
  }
`;
const GlobalStyle = createGlobalStyle `
  ${CssVar}
`;
export const GranenThemeProvider = (_a) => {
    var { defaultThemeType = defaultConfig.type } = _a, props = __rest(_a, ["defaultThemeType"]);
    const [theme, setTheme] = useState(defaultThemeType);
    const [, api] = useSpring(() => (Object.assign(Object.assign({}, Themes[defaultThemeType].color), { onChange: (x) => {
            setThemeCssVariable(x.value);
        } })));
    const handleChangeTheme = useCallback(() => {
        setTheme((prev) => {
            let next = 'light';
            if (prev === 'light') {
                next = 'dark';
            }
            else {
                next = 'light';
            }
            api.start(Object.assign({}, Themes[next].color));
            return next;
        });
    }, [api]);
    return (React.createElement(GranenThemeContext.Provider, { value: { type: theme, handleChangeTheme } },
        React.createElement(ThemeProvider, { theme: Themes[theme] },
            React.createElement(GlobalStyle, null),
            props.children)));
};
